/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the pay-per-use conversion flow: after a first-time pay-per-use patient finishes a paid visit, a follow-up notification (1h) and a membership promo-code email (4h) are scheduled. Off when absent.
 * @export
 * @interface PpuPromoModule
 */
export interface PpuPromoModule {
    /**
     * 
     * @type {boolean}
     * @memberof PpuPromoModule
     */
    enabled?: boolean;
    /**
     * Dollar amount of the credit offered by the pay-per-use conversion promo (coupon value and email copy). Falls back to the legacy $100 default when absent.
     * @type {number}
     * @memberof PpuPromoModule
     */
    credit_amount?: number;
}

/**
 * Check if a given object implements the PpuPromoModule interface.
 */
export function instanceOfPpuPromoModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PpuPromoModuleFromJSON(json: any): PpuPromoModule {
    return PpuPromoModuleFromJSONTyped(json, false);
}

export function PpuPromoModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PpuPromoModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'credit_amount': !exists(json, 'credit_amount') ? undefined : json['credit_amount'],
    };
}

export function PpuPromoModuleToJSON(value?: PpuPromoModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'credit_amount': value.credit_amount,
    };
}

